import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class ConfigService {

  private config: any;

  constructor( private readonly http: HttpClient) { }

  async loadConfig(): Promise<void> {
try{
  const data = await firstValueFrom(this.http.get('../assets/json/config.json'));
  this.config = data;
}catch(error){
  console.log(error);
}
  }

  getConfig(){
    return this.config;
  }
}
